
const rtl = (document.querySelector('html').getAttribute('dir') == 'rtl');
/**
 * Media Browser
 */
class GallerySlideshow {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.slider = this.el.querySelector('[data-slider]');
    this.initSlider();
  }
  initSlider() {
    this.prevArrow = this.el.querySelector('[data-slider-pager][data-dir-prev]');
    this.nextArrow = this.el.querySelector('[data-slider-pager][data-dir-next]');
    $(this.slider).slick({
      speed: 1000,
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      dots: false,
      arrows: true,
      prevArrow: this.prevArrow,
      nextArrow: this.nextArrow,
      rtl
    });
  }
  initThumbs() {
    $(this.thumbs).slick({
      speed: 1000,
      infinite: false,
      autoplay: false,
      arrows: false,
      dots: false,
      slidesToShow: 9,
      slidesToScroll: 1,
      swipeToSlide: true,
      focusOnSelect: true,
      centerMode: false,
      rtl,
      asNavFor: this.slider,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}

export default function () {
  const browser = new GallerySlideshow(document.querySelector('[data-gallery-slideshow]'));
}



// WEBPACK FOOTER //
// ./public/javascripts/modules/gallery-slideshow.js